import {
  Menu,
  MenuButton,
  MenuList,
  Button,
  MenuOptionGroup,
  MenuItemOption,
  ChevronDownIcon,
} from '@cdl/heartbeat-react';
import { useDispatch } from 'react-redux';
import { ClusterType, Cluster } from '../../clustering.types';
import React, { useCallback, useMemo } from 'react';
import { CLUSTER_CODES } from '../../client/helpers';
import { reclassifyClusters } from '../../thunks/reclassify-clusters.thunk';

interface Props {
  clusters: Cluster[];
  title?: string;
}

const WIDTH = '9.375rem';

export const ClassificationDropdown: React.FC<Props> = ({
  clusters,
  title,
}) => {
  const dispatch = useDispatch();
  const onchangeClusterType = useCallback(
    (code: ClusterType) => {
      dispatch(reclassifyClusters(code, clusters));
    },
    [dispatch, clusters],
  );
  const selectedValue = useMemo(
    () => title ?? clusters[0].classification,
    [clusters, title],
  );

  return (
    <Menu matchWidth>
      <MenuButton
        as={Button}
        rightIcon={<ChevronDownIcon />}
        variant='secondary'
        textAlign='left'
        fontWeight='regular'
        width={WIDTH}
      >
        {selectedValue}
      </MenuButton>
      <MenuList minWidth='unset'>
        <MenuOptionGroup
          type='radio'
          onChange={(v) => onchangeClusterType(v as ClusterType)}
          value={selectedValue}
        >
          {Object.values(CLUSTER_CODES).map((clusterType) => (
            <MenuItemOption key={clusterType} value={clusterType}>
              {clusterType}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  );
};
